<template>
	<div>
		<div>
			<b-button @click="goBackToFrom" variant="outline-dark">
				<i class="fa fa-chevron-left"></i> {{ $t('back') }}
			</b-button>
			<b-button style="position: absolute; right: 20px" variant="success" @click="saveRequestDoc">
				{{ $t('save-finish') }}
			</b-button>
		</div>
		<b-card class="mt-2">
			<div slot="header" class="d-flex justify-content-between custom-card-header">
				<span class="card-header-title"> {{
						$t('sidebar.warehouse-management.requests')
					}} - <b>{{ items.items[0].fromDep ? items.items[0].fromDep.department_name : `` }}</b></span>
				<div class="card-header-actions">
					<div class="searchInCard">
						<b-input-group size="sm">
							<b-form-input
								v-model="payload.value"
								@input="getList"
								size="sm"
								:placeholder="$t('contragent.filter')"
								autocomplete="off"/>
							<b-input-group-append>
								<b-button :disabled="!payload.value" @click="getList(payload.value = '')">
									{{ $t('contragent.clear') }}
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</div>
				</div>
			</div>
			<table class="table table-hover table-bordered table-striped mt-3">
				<thead>
				<tr v-if="items.items.length || items.items">
					<th class="text-center">№</th>
					<th class="text-center">{{ $t('goods.name') }}</th>
					<th class="text-center">{{ $t('goods.barcode') }}</th>
					<th class="text-center">{{ $t('goods.special-barcode') }}</th>
					<th class="text-center">{{ $t('kirim.expirationDate') }}</th>
					<th class="text-center">{{ $t('incomes.create.price') }}</th>
					<th class="text-center">{{ items.items[0].fromDep.department_name }}</th>
					<th class="text-center" v-for="(deps, index) in items.items[0].toDeps">
						{{ deps.departmentName }}
					</th>
				</tr>
				<tr v-else>
					<th class="text-center">№</th>
					<th class="text-center">{{ $t('goods.name') }}</th>
					<th class="text-center">{{ $t('goods.barcode') }}</th>
					<th class="text-center">{{ $t('goods.special-barcode') }}</th>
					<th class="text-center">{{ $t('promo-to-product.department') }}</th>
				</tr>
				</thead>
				<tbody>
				<template v-if="items.items.length || items.items">
					<tr v-for="(item, index) in items.items" :key="`item-${index}`">
						<td class="text-center">{{ paginate(index, payload.page, payload.limit) }}</td>
						<td>{{ item.itemName }}</td>
						<td class="text-center">
							<span v-for="(barcode, index) in item.multiBarcode" :key="`multi-barcode-${index}`" style="margin-top: 10px">
								<span>{{ barcode }}</span><br>
							</span>
						</td>
						<td class="text-center">{{ item.barcode }}</td>
						<td class="text-center">{{ item.termOfItem }}</td>
						<td class="text-center">{{ item.priceUzs }}</td>
						<td class="text-center">{{ item.fromDep.remaining }}</td>
						<td class="text-center" v-for="(deps, index) in item.toDeps">
							<div v-if="deps.count">
								{{ deps.count }}
								<b-form-input
									v-model="deps.sendCount"
									:min="0"
									@blur="updateRequestCount(deps, item)"
									type="number"
								/>
							</div>
						</td>
					</tr>
				</template>
				<tr v-else>
					<td colspan="4" class="text-center">
						<h5><b>Информация не найдена !</b></h5>
					</td>
				</tr>
				</tbody>
			</table>
			<nav>
				<b-pagination
					:total-rows="items.total"
					:per-page="payload.limit"
					v-model="payload.page"
					aria-controls="table"/>
			</nav>
		</b-card>
	</div>
</template>

<script>
import WhDocument from "@/services/wh-document.service";

export default {
	name: "CreateOrUpdate",
	data() {
		return {
			docs: {},
			items: {items: []},
			count: null,
			payload: {
				page: 1,
				limit: 20,
				subCategoryId: null,
				sub2CategoryId: null,
				sub3CategoryId: null,
				fromDepartmentId: null,
				requestDocId: null,
				toDepartmentIds: [],
				value: ''
			}
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		async getList() {
			this.payload.subCategoryId = this.docs.subCategoryId
			this.payload.sub2CategoryId = this.docs.sub2CategoryId
			this.payload.sub3CategoryId = this.docs.sub3CategoryId
			this.payload.fromDepartmentId = this.docs.fromDepartmentId
			this.payload.requestDocId = this.docs.id
			this.payload.toDepartmentIds = []
			this.docs.toDepartments.forEach(t => {
				this.payload.toDepartmentIds.push(t.id)
			})
			await WhDocument.getRequestTransferCreateListForCounter(this.payload).then(res => {
				this.items = res.data
			})
		},
		async updateRequestCount(deps, item) {
			if (deps.sendCount < 0 || deps.sendCount == '') {
				deps.sendCount = 0
			}
			if (deps.sendCount > deps.count) {
				deps.sendCount = deps.count
			}
			let data = {
				requestDocumentId: this.$route.params.id,
				itemId: deps.itemId,
				count: deps.count,
				sendCount: deps.sendCount,
				departmentId: deps.departmentId,
				termOfItem: item.termOfItem,
				priceUzs: item.priceUzs
			}
			await WhDocument.updateRequestCount(data).then(res => {
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		saveRequestDoc() {
			let wh = true
			this.items.items.forEach(item => {
				item.toDeps.forEach(t => {
					if (t.sendCount < 0) {
						wh = false
					}
				})
			})
			if (wh) {
				this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
					hideHeader: true,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: this.$t('actions.yes'),
					cancelTitle: this.$t('actions.no'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if (value) {
						WhDocument.saveRequestDoc('CHECKED', this.$route.params.id).then(res => {
							this.$router.go(-1)
							this.$vs.notify({
								title: 'Success',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							})
						})
					}
				})
			} else {
				this.$vs.notify({
					title: this.$t('words.error'),
					text: this.$t('words.validation-error'),
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		}
	},
	watch: {
		'payload.page': {
			async handler(newVal) {
				await this.getList()
			}
		},
	},
	async created() {
		await WhDocument.getRequestDocById(this.$route.params.id).then(res => {
			this.docs = res.data
		})
		this.getList();
	}
}
</script>

<style scoped>

</style>
